import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";
import {$contentTemplates} from "../$content-templates.factory";
import {ContentTemplateModel} from "../models/content-template.model";

export class ContentTemplatesRequestsService {

  constructor(private ContentTemplatesAPI: BringozApi, private $contentTemplates: $contentTemplates) {
  }

  getExternalTemplate(externalTemplateId: string) {
    const api = this.ContentTemplatesAPI.actions.getExternalTemplate;
    return this.$$call(api, {}, {}, {externalTemplateId: externalTemplateId});
  }

  createTemplate(contentTemplate: ContentTemplateModel) {
    const api = this.ContentTemplatesAPI.actions.createContentTemplate;
    return this.$$call(api, {}, contentTemplate, {});
  }

  editTemplate(contentTemplateId: string, contentTemplate: ContentTemplateModel) {
    const api = this.ContentTemplatesAPI.actions.editContentTemplate;
    return this.$$call(api, {}, contentTemplate, {contentTemplateId: contentTemplateId});
  }

  deleteTemplate(contentTemplateId: string) {
    const api = this.ContentTemplatesAPI.actions.deleteContentTemplate;
    return this.$$call(api, {}, {}, {contentTemplateId: contentTemplateId});
  }

  // ******************************
  //        Private methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$contentTemplates().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.content-templates')
  .service('contentTemplatesRequestsService', ContentTemplatesRequestsService);
